/* tslint:disable */

/**
 * The error code :
 *   * "10.XXX" : errors related to carrier management
 *   * "12.XXX" : errors related to tank management
 *   * "50.XXX" : errors related to delivery management
 *   * "60.XXX" : errors related to delivery publication
 *   * "70.XXX" : errors related to invoice management
 *   * "99.XXX" : other errors
 */
type ErrorCode =
  '10.001' |
  '12.001' |
  '50.002' |
  '50.003' |
  '50.004' |
  '50.005' |
  '50.006' |
  '50.007' |
  '50.008' |
  '50.009' |
  '60.001' |
  '70.001' |
  '99.001' |
  '99.002' |
  '99.003' |
  '99.004' |
  '99.005' |
  '99.006' |
  '99.007' |
  '99.008' |
  '99.999';
namespace ErrorCode {
  export const _10_001: ErrorCode = '10.001';
  export const _12_001: ErrorCode = '12.001';
  export const _50_002: ErrorCode = '50.002';
  export const _50_003: ErrorCode = '50.003';
  export const _50_004: ErrorCode = '50.004';
  export const _50_005: ErrorCode = '50.005';
  export const _50_006: ErrorCode = '50.006';
  export const _50_007: ErrorCode = '50.007';
  export const _50_008: ErrorCode = '50.008';
  export const _50_009: ErrorCode = '50.009';
  export const _60_001: ErrorCode = '60.001';
  export const _70_001: ErrorCode = '70.001';
  export const _99_001: ErrorCode = '99.001';
  export const _99_002: ErrorCode = '99.002';
  export const _99_003: ErrorCode = '99.003';
  export const _99_004: ErrorCode = '99.004';
  export const _99_005: ErrorCode = '99.005';
  export const _99_006: ErrorCode = '99.006';
  export const _99_007: ErrorCode = '99.007';
  export const _99_008: ErrorCode = '99.008';
  export const _99_999: ErrorCode = '99.999';
  export function values(): ErrorCode[] {
    return [
      _10_001,
      _12_001,
      _50_002,
      _50_003,
      _50_004,
      _50_005,
      _50_006,
      _50_007,
      _50_008,
      _50_009,
      _60_001,
      _70_001,
      _99_001,
      _99_002,
      _99_003,
      _99_004,
      _99_005,
      _99_006,
      _99_007,
      _99_008,
      _99_999
    ];
  }
}

export { ErrorCode }